<template>
  <div class="home_main">
    <!-- Loader -->
    <div class="page_loader_cont" v-if="page_loader">
      <div class="spinner_height">
        <spinner-circle :black="true"></spinner-circle>
      </div>
    </div>

    <!-- Content -->
    <div class="heading_cont_" v-else>
      <div class="row heading_cont_">
        <h3>Employees</h3>
        <div class="money" @click="open_add_new()">Add Employee</div>
      </div>

      <!-- Cards -->
      <div v-if="employees && employees.length > 0">
        <div class="employees_grid">
          <div class="employee_card" v-for="(employee, i) in employees" :key="employee.id">

            <!-- Avatar -->
            <div class="avatar avatar_img" v-if="employee.profile_pic" :style="{
              backgroundImage: `url(${linkk}/${employee.profile_pic})`
            }"></div>
            <div class="avatar" v-else>
              <img :src="`https://ui-avatars.com/api/?name=${employee.name}&background=317BEB&color=fff`"
                alt="employee" />
            </div>

            <!-- Info -->
            <div class="card_info">
              <h4>{{ employee.name }}</h4>
              <p><strong>Role:</strong> {{ employee.role }}</p>
              <p><strong>Branch:</strong> {{ employee.branch }}</p>
            </div>

            <!-- Actions -->
            <div class="card_actions">

              <!-- <img
                @click="open_delete(i)"
                src="@/assets/delete.svg"
                alt="delete"
                class="edit_icon deletos"
              /> -->

              <img @click="open_update_emp(employee.id, i)" src="@/assets/edit.svg" alt="edit" class="edit_icon" />
            </div>
          </div>
        </div>
      </div>

      <!-- No result -->
      <div class="no_result no_result_center" v-else>
        you did not have any employees.
      </div>

      <!-- Overlay -->
      <div class="modal_overlay" v-if="show_add_employee" @click.self="close_modal">
        <div class="modal_card">
          <!-- Close button -->
          <div class="modal_close" @click="close_modal">✕</div>

          <h3>Add Employee</h3>

          <form class="super_form" enctype="multipart/form-data">
            <input type="text" placeholder="Username" v-model="super_username" />

            <input v-if="['manager', 'sales', 'social'].includes(manager_role)" type="text" placeholder="Password"
              v-model="super_password" />

            <!-- <label class="select_label">Role</label> -->
            <select v-model="manager_role">
              <!-- <option value="" disabled>Select role</option> -->
              <option value="manager" v-if="role === 'owner'">Manager</option>
              <option value="sales">Sales</option>
              <option value="social">Social</option>
              <option value="cashier">Cashier</option>
              <option value="groomer">Groomer</option>
            </select>


            <select v-model="owner_selected_branch" v-if="role === 'owner'">
              <option value="beverly_hills">Beverly Hills</option>
              <option value="palm_hills">Palm Hills</option>
            </select>

            <!-- Image preview -->
            <div class="image_preview" v-if="image_preview">
              <div class="preview_avatar" :style="{ backgroundImage: `url(${image_preview})` }"></div>
            </div>

            <!-- Upload -->
            <label for="file-input" class="file_input_label">
              Upload employee picture
            </label>
            <input type="file" accept="image/*" @change="uploadImage" ref="img" class="hidden" id="file-input" />

            <button @click.prevent="add_emp()">
              <!-- <span v-if="super_loading">Loading...</span> -->
              <spinner v-if="super_loading"></spinner>
              <span v-else>Save</span>
            </button>
          </form>
        </div>
      </div>





      <!-- Overlay -->
      <div class="modal_overlay" v-if="open_update_emp_" @click.self="close_update_emp()">
        <div class="modal_card">
          <!-- Close button -->
          <div class="modal_close" @click="close_update_emp()">✕</div>

          <h3>Update Employee</h3>

          <form class="super_form" enctype="multipart/form-data">


            <!-- <input type="text" placeholder="Username" v-model="super_username" />

            <input v-if="['manager', 'sales', 'social'].includes(manager_role)" type="text" placeholder="Password"
              v-model="super_password" /> -->

            

            <!-- <select v-model="manager_role">
              <option value="manager" v-if="role === 'owner'">Manager</option>
              <option value="sales">Sales</option>
              <option value="social">Social</option>
              <option value="cashier">Cashier</option>
              <option value="groomer">Groomer</option>
            </select> -->


            <!-- <select v-model="owner_selected_branch" v-if="role === 'owner'">
              <option value="beverly_hills">Beverly Hills</option>
              <option value="palm_hills">Palm Hills</option>
            </select> -->

            <!-- Image preview -->
            <div class="image_preview" v-if="image_preview">
              <div class="preview_avatar" :style="{ backgroundImage: `url(${image_preview})` }"></div>
            </div>

            <!-- Upload -->
            <label for="file-input" class="file_input_label">
              Upload employee picture
            </label>
            <input type="file" accept="image/*" @change="uploadImage" ref="img" class="hidden" id="file-input" />

            <button @click.prevent="update_emp()">
              <!-- <span v-if="super_loading">Loading...</span> -->
              <spinner v-if="super_update_loading"></spinner>
              <span v-else>Save</span>
            </button>
          </form>
        </div>
      </div>




    </div>
  </div>
</template>

<script>
import request from '../axios_request';
import Spinner from '@/components/Spinner.vue';
import SpinnerCircle from './SpinnerCircle.vue';
import { mapState, mapActions } from 'vuex';


export default {
  name: "EmployeesComp",

  components: {
    SpinnerCircle,
    Spinner,

  },

  data() {
    return {
      employees: null,
      page_loader: true,
      linkk: process.env.VUE_APP_SERVER_ENDPOINT,
      show_add_employee: false,
      image_preview: null,
      manager_role: 'social',
      owner_selected_branch: 'beverly_hills',
      super_password: null,
      super_username: null,
      super_loading: false,
      img: null,
      add_err: null,
      open_update_emp_: false,
      super_update_loading: false,
      id_x: null,
      update_index: null

    };
  },

  created() {


        if( localStorage.getItem('token') ){
            var token = localStorage.getItem('token');
            request.post('/api/system/is_logged', {token})//, config
            .then((response)=>{
            // console.log(response);
                if( response.status === 200 ){
                    // console.log(response.data);
                    this.set_logged_in(true);
                    this.role_(response.data.role);
                    this.admin_name_(response.data.name);
                    this.company_(response.data.company);
                    this.branch_(response.data.branch);


                    request.get('/api/system/get_all_company_employees')
                      .then((response) => {
                        if (response.status === 200) {
                          this.employees = response.data;
                          this.page_loader = false;
                          console.log("Fetched Employees:", response.data);
                        }
                      })
                      .catch((error) => {
                        console.error("Error fetching Employees:", error);
                        this.page_loader = false;
                      });


                }else{
                    //not logged
                    this.set_logged_in(false);
                    this.role_(null);
                    localStorage.clear();
                    this.$router.push({name: 'admin_login'});
                }

            }).catch((e) => {
                console.log(e);
                this.set_logged_in(false);
                this.role_(null);
                localStorage.clear();
                this.$router.push({name: 'admin_login'});
            });


        }else{
            this.set_logged_in(false);
            this.role_(null);
            localStorage.clear();
            this.$router.push({name: 'admin_login'});
        }










  },

  methods: {

        ...mapActions([
            'set_logged_in',
            'role_',
            'company_logo_',
            'admin_name_',
            'company_',
            'branch_',
        ]),



    open_update_emp(id, i) {
      this.id_x = id;
      this.open_update_emp_ = true;
      this.update_index = i;

    },
    close_update_emp() {
      // console.log('edit employee', this.employees[i]);
      this.open_update_emp_ = false;

    },

  update_emp(){
    if( this.super_update_loading === true ){
      return;
    }

    this.super_update_loading = true;

    var data = new FormData();
    data.append('id_x', this.id_x);
    data.append('name', this.employees[this.update_index].name);
    data.append('profile_pic', this.img);


    // 
    request
    .post('/api/system/update_employee', data)//, config
    .then(() => {
        // this.d_d_error = null;
        // this.close_delete();
        //now get the employees
        request.get('/api/system/get_all_company_employees')
        .then((response) => {
          if (response.status === 200) {
            this.employees = response.data;
            // this.page_loader = false;
            this.super_update_loading = false;
            this.close_update_emp();
            console.log("Fetched Employees:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching Employees:", error);
          // this.page_loader = false;
        });
    })
    .catch((update_err) => {
        console.log(update_err);
        // this.d_d_error = 'error';
        this.super_update_loading = false;
    });
    
  },

    open_delete(i) {
      console.log('delete employee', this.employees[i]);
    },

    open_add_new() {
      this.show_add_employee = true;
    },

    close_modal() {
      this.show_add_employee = false;
      this.image_preview = null;
      this.clear_form();
    },

    uploadImage(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.img = file;
      this.image_preview = URL.createObjectURL(file);
    },

    clear_form(){


      this.image_preview = null;
      this.manager_role = 'social';
      this.owner_selected_branch = 'beverly_hills';
      this.super_password = null;
      this.super_username =  null;
      this.img = null;
      this.add_err = null;

    },

    add_emp(){


          if( this.super_loading && this.super_loading === true ){
                return;
            }

            
            this.super_loading = true;

            if(!this.super_username || this.super_username.length === 0){
              this.add_err = 'must enter name.';
              this.super_loading = false;
              return
            }

            const data = new FormData();

            data.append('username',  this.super_username);
            data.append('password',  this.super_password);
            data.append('role',  this.manager_role);

            if( this.role === 'owner' ){
              data.append('branch',  this.owner_selected_branch);
            }

            data.append('profile_pic', this.img);
            

            request
                .post('/api/system/add_employee', data, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                })//, config
                .then((d) => {
                  console.log(d);
                  if(d && d.status && d.status === 201){



                    // load all groomers
                    request.get('/api/system/get_all_company_employees')
                      .then((response) => {
                        if (response.status === 200) {
                          this.employees = response.data;

                          this.add_err = null;
                          this.super_loading = false;
                          this.close_modal();
                          this.clear_form();
                        }
                      })
                      .catch((u_e) => {
                        console.log(u_e);

                        this.add_err = 'error';
                        this.super_loading = false;
                      });



                  }else{
                    this.add_err = 'error';
                    this.super_loading = false;  
                  }

                })
                .catch((add_groomer_err) => {
                    console.log(add_groomer_err);
                    this.add_err = 'error';
                    this.super_loading = false;
                });



    }

  },


  computed: {
    ...mapState([
      'role',
    ]),
  }


}
</script>

<style scoped>
.home_main {
  padding: 20px 15px;
}

/* Header */
.heading_cont_ {
  justify-content: space-between;
  align-items: center;
}

.money {
  color: #317BEB;
  cursor: pointer;
  font-size: 17px;
  font-weight: 500;
}

/* Grid */
.employees_grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

/* Card */
.employee_card {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, .08);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Avatar */
.avatar {
  display: flex;
  justify-content: center;
}

.avatar img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

/* Info */
.card_info h4 {
  margin: 0;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.card_info p {
  margin: 3px 0;
  font-size: 16px;
  color: #555;
}

/* Actions */
.card_actions {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.edit_icon {
  height: 26px;
  cursor: pointer;
}

/* No result */
.no_result_center {
  padding: 10px;
  border-radius: 3px;
  width: 100%;
  background-color: #cccccc8c;
  text-align: center;
  color: #373737;
  font-weight: 500;
  margin-top: 15px;
}

.avatar_img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  margin: auto;

  background-color: #f2f2f2;
  /* fallback */
}

.deletos {
  display: none;
}

/* Overlay */
.modal_overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* Popup Card */
.modal_card {
  background: #fff;
  width: 100%;
  max-width: 420px;
  border-radius: 12px;
  padding: 25px 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: popIn 0.2s ease;
  padding-top: 0px;
}

/* Title */
.modal_card h3 {
  margin: 0 0 20px;
  text-align: center;
  font-size: 24px;
}

/* Form */
.super_form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.super_form input,
.super_form select {
  height: 45px;
  padding: 0 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1.5px solid #ccc;
  outline: none;
  transition: 0.15s;
}

.super_form input:focus,
.super_form select:focus {
  border-color: #317BEB;
}

/* Select label */
.select_label {
  font-size: 14px;
  color: #555;
  margin-top: 5px;
}

/* File input */
.file_input_label {
  text-align: center;
  padding: 12px;
  border: 2px dashed #317BEB;
  border-radius: 8px;
  cursor: pointer;
  color: #317BEB;
  font-weight: 500;
  transition: 0.15s;
}

.file_input_label:hover {
  background: #317beb10;
}

.hidden {
  display: none;
}

/* Button */
.super_form button {
  height: 45px;
  border-radius: 8px;
  background: #317BEB;
  color: white;
  font-size: 18px;
  border: none;
  cursor: pointer;
  margin-top: 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

}

.super_form button:hover {
  opacity: 0.9;
}

/* Animation */
@keyframes popIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .modal_card {
    margin: 0 15px;
  }
}



/* Close button */
.modal_close {
  position: relative;
  top: 12px;
  right: 12px;
  font-size: 20px;
  cursor: pointer;
  color: #777;
  transition: 0.15s;
  width: fit-content;
}

.modal_close:hover {
  color: red;
}

/* Image preview */
.image_preview {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.preview_avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  border: 2px solid #317BEB;
}


/* Mobile */
@media (max-width: 600px) {
  .employees_grid {
    grid-template-columns: 1fr;
  }
}
</style>
